import React, { useState, useEffect } from 'react';
import { Alert, Card, Button, Form, Modal, ListGroup, Tabs, Tab,OverlayTrigger, Popover } from 'react-bootstrap'
import Select from 'react-select';
import axios from 'axios';
import { useLocation } from "react-router-dom";
import Moment from 'moment';
import { addDays, addYears, subYears } from 'date-fns'
import SHA256 from "crypto-js/sha256";
import CurrencyInput from 'react-currency-input-field';
import DatePicker from 'react-datepicker';
import { isNull } from 'lodash';
import ReactGA from "react-ga";

export default function BikeIns() {
    let query = new URLSearchParams(useLocation().search);
    const [key, setKey] = useState(query.get("paymentID") === null ? 'Sum' : query.get("keyTab"));
    const [ownerInfo, setOwnerInfo] = useState([]);
    const [bikeInfo, setBikeInfo] = useState([]);
    const [sumInfo, setSumInfo] = useState([]);
    const [beneficiaryInfo, setBeneficiaryInfo] = useState([]);

    return (
        <section id="body">
            <div className="container">
                <div className="row shadow title position-relative">
                    <div className="col-12">
                        <h2 className="text-center m-5 text-white fw-bold">Bicycle Insurance</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-1"></div>
                    <div className="col-10 px-0 shadow bg-white rounded">
                        <Tabs activeKey={key} variant="tabs" onSelect={(k) => setKey(k)}>
                            <Tab eventKey="Sum" title="Step 1: Get Quote">
                                <Sum setKey={setKey} setSumInfo={setSumInfo} />
                            </Tab>
                            <Tab eventKey="owner" title="Step 2: My Info">
                                <Owner setKey={setKey} setOwnerInfo={setOwnerInfo} sumInfo={sumInfo} />
                            </Tab>
                            <Tab eventKey="bike" title="Step 3: Bicycle Info" >
                                <Bike setKey={setKey} setBikeInfo={setBikeInfo} sumInfo={sumInfo}  />
                            </Tab>
                            {/*<Tab eventKey="beneficiary" title="Step 4: Beneficiary Info">
                                <Beneficiary setKey={setKey} setBeneficiaryInfo={setBeneficiaryInfo} />
                            </Tab>*/}
                            <Tab eventKey="payment" title="Step 4: Payment">
                                <Payment setKey={setKey} ownerInfo={ownerInfo} bikeInfo={bikeInfo} sumInfo={sumInfo} />
                            </Tab>
                        </Tabs>
                    </div>
                    <div className="col-1"></div>
                </div>
            </div>
        </section>
    );
}

function Sum(props) {
    const [sumName, setSumName] = useState("");
    const [sumContactNo, setSumContactNo] = useState("");
    const [sumBikeModel, setSumBikeModel] = useState("");
    const [sumInsured, setSumInsured] = useState("");
    const [sumOInsured, setOSumInsured] = useState("");
    const [sumStartDate, setSumStartDate] = useState(new Date());
    const [sumEndDate, setSumEndDate] = useState(addDays(addYears(new Date(), 1), -1));
    const [paShield] = useState(103);
    const [rdPaShield, setRdPaShield] = useState(true);
    const [showInfo, setshowInfo] = React.useState(false);
    
    const [grossPremium, setgrossPremium] = useState("");
    var lessthanMinPremium=false;

    function onClickNext(e) {
        const form = e.currentTarget;

        window.sessionStorage.clear();
        window.sessionStorage.setItem("sessionBikeModel", sumBikeModel);

	CheckMinPremium();
        if ((form.checkValidity() !== false)) {
		
            e.preventDefault();
            e.stopPropagation();

            props.setSumInfo({
                sumName: sumName,
                sumContactNo: sumContactNo,
                sumInsured: sumInsured,
                sumOInsured: sumOInsured,
                sumStartDate: sumStartDate,
                sumEndDate: sumEndDate,
                sumBikeModel: sumBikeModel
            });

            props.setKey("owner");
        }

	
    }

    function CheckMinPremium() {

	if ((parseFloat(idsuminsured.text)* 0.04)<100) {
		//alert("Opps...\nSorry, the minimum gross premium is RM100.\nPlease change the sum insured before continuing.");
		//BtnBuyNow.disabled=true;
		//lessthanMinPremium=true;
                setgrossPremium(100);

	}
	//else{
	//	BtnBuyNow.disabled=false;
	//	lessthanMinPremium=false;
	//}	
	setshowInfo(true);	
    }

    function ChangeSumInsured(value) {
	BtnBuyNow.disabled=false;
	setSumInsured(value);
	idsuminsured.text=value;
	setgrossPremium((sumInsured * 0.04)>=100?(sumInsured * 0.04):100);
    }

   
    return (
        <Form validated={false} onSubmit={(e) => onClickNext(e)}>
            <Card>
                <Card.Body>
                    <div className="mb-3 row">
                        <label className="col-md-5 col-form-label">Full Name</label>
                        <div className="col-md-7">
                            <input type="text" className="form-control" required value={sumName} onChange={(e) => setSumName(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-md-5 col-form-label">Contact Number</label>
                        <div className="col-md-7">
                            <input type="text" className="form-control" required value={sumContactNo} onChange={(e) => setSumContactNo(e.target.value)} pattern="\d*" maxLength="11" placeholder="012xxxxxxxx" />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-md-5 col-form-label">Bicycle Make / Model</label>
                        <div className="col-md-7">
                            <input type="text" className="form-control" required value={sumBikeModel} onChange={(e) => setSumBikeModel(e.target.value)} placeholder="Trek, Domance SL6 to Trek, Madone SL" />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-md-5 col-form-label">Coverage Date</label>
                        <div className="col-md-7">
                            <div className="mb-3 row">
                                <label className="col-md-2 col-form-label"><small>From</small></label>
                                <div className="col-md-4">
                                    <DatePicker closeOnScroll={true} dateFormat="dd/MM/yyyy" className="form-control" required selected={sumStartDate} minDate={new Date()} onChange={date => { setSumStartDate(date); setSumEndDate(addDays(addYears(date, 1), -1)); }} />
                                </div>
                                <label className="col-md-2 col-form-label"><small>To</small></label>
                                <div className="col-md-4">
                                    <DatePicker closeOnScroll={true} dateFormat="dd/MM/yyyy" className="form-control" selected={sumEndDate} disabled />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-md-5 col-form-label">Enter sum insured (RM) </label>
                        <div className="col-md-7">
                            <CurrencyInput
                                id="propertyRentalAmt"
                                autoComplete="none"
                                allowNegativeValue={false}
                                decimalSeparator="."
                                groupSeparator=","
                                className="form-control"
                                onChange={(value) => ChangeSumInsured(value)}
                                required
                                value={sumInsured}
                                placeholder="You may determine the sum insured as per purchase receipt."
                            />
                        </div>
                    </div>
                    <div className="d-none">
                        <label className="col-md-5 col-form-label ">I would like to insured my bicycle for RM</label>
                        <div className="col-md-7">
                            <CurrencyInput
                                id="propertyRentalAmt"
                                allowNegativeValue={false}
                                decimalSeparator="."
                                groupSeparator=","
                                className="form-control"
                                decimalsLimit={2}
                                onChange={(value) => setOSumInsured(value)}
                                precision={2}
                                value={sumOInsured}
                            />
                        </div>
                    </div>
                    <div className="mb-3 row mt-5 align-items-center">
                        <div className="col-12 text-end">
                            <Button variant="success" onClick={() => CheckMinPremium()}>Continue</Button>
                        </div>
                    </div>
                    <div id="premSection" style={{ display: showInfo ? "block" : "none" }}>
                        <Card className="my-2">
                            <Card.Header className="text-primary fw-bold">Summary of Policy</Card.Header>
                            <Card.Body>
                                <div className="row">
                                    <div id="payment" className="col-md-6">

 
                                        <div className="mb-3 row">
                                            <label className="col-6 col-form-label">Bicycle Sum Insured</label>
                                            <label className="col-6 col-form-label text-end" >RM {parseFloat(sumInsured === "" ? 0 : sumInsured).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</label>
					   <input type="hidden" name="TransactionType" id="idsuminsured"/>
                                        </div>
                                         {/*<div className="mb-3 row">
                                            <label className="col-6 col-form-label">Premium</label>
                                            <label className="col-6 col-form-label text-end">RM {(parseFloat(sumInsured * 0.04)).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')<100? 100 : 
(parseFloat(sumInsured * 0.04)).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</label>
                                        </div>
                                        <div className="mb-3 row">
                                            <label className="col-6 col-form-label">Stamp Duty</label>
                                            <label className="col-6 col-form-label text-end">RM 10.00</label>
                                        </div>*/}
					   <div className="mb-3 row mt-5 align-items-center">
                        <div className="col-12 text-end">
                            <Button variant="success" onClick={() => CheckMinPremium()}>Get Quote</Button>
                        </div>
                    </div>

                                    </div>
                                    {/*<div id="payment" className="col-md-6">
                                        <div className="mb-3 row mb-0">
                                            <label className="col-12 col-form-label fw-bold pb-0">
                                                <input
                                                    name="rdPaShield"
                                                    id="rdPaShieldYes"
                                                    type="checkbox"
                                                    className="form-check-input mt-2 hidden"
                                                    defaultChecked={rdPaShield}
                                                    onChange={() => setRdPaShield(!rdPaShield)}
                                                    disabled
                                                />
                                                    Allianz Shield Plus
                                                </label>
                                        </div>
                                        <div className="mb-3 row">
                                            <label className="col-6 col-form-label">Sum Insured</label>
                                            <label className="col-6 col-form-label text-end">RM 60,000.00</label>
                                        </div>
                                        <div className="mb-3 row">
                                            <label className="col-6 col-form-label">Premium</label>
                                            <label className="col-6 col-form-label text-end">RM 103.00</label>
                                        </div>
                                        <div className="mb-3 row">
                                            <label className="col-6 col-form-label">Stamp Duty</label>
                                            <label className="col-6 col-form-label text-end">RM 10.00</label>
                                        </div>
                                        <div className="mb-3 row">
                                            <label className="col-6 col-form-label">Service Tax 8%</label>
                                            <label className="col-6 col-form-label text-end">RM {((parseFloat(sumInsured * 0.04) + paShield) * 0.06).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</label>
                                        </div>
                                    </div>*/}
                                </div>
                            </Card.Body>
                            <Card.Footer>
                                <div className="row fw-bold">
                                        <label className="col-6 col-form-label">Gross Premium <OverlayTrigger data-html="true"
                                            trigger={['hover', 'click']}
                                            key={"o1"}
                                            placement="right"
                                            overlay={
                                                <Popover id={`popover-positioned-left`}>
                                                    <Popover.Content>
                                                        Minimum RM100.00 or 4% of Sum Insured, whichever is higher
						  </Popover.Content>
                                                </Popover>
                                            }
                                        >
                                         <i className="fa fa-question-circle text-primary ms-2" aria-hidden="true"></i>
                                        </OverlayTrigger>
  					</label> 
  			 		<label className="col-6 col-form-label text-end" style={{ color: (grossPremium>=100 == true ? "black" : "red") }}>
                                         RM {parseFloat(grossPremium).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                                            
          			  </label>    			
     					

                                    
                                </div>
                                    {/*<div className="row fw-bold bg-primary text-white">
                                    <label className="col-6 col-form-label">{process.env.MIX_DISC_PERCENTAGE}% Rebate</label>
                                    <label className="col-6 col-form-label text-end">
                                        RM ({parseFloat((grossPremium ) * (process.env.MIX_DISC_PERCENTAGE / 100))
                                            .toLocaleString(undefined, { minimumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                        })
                                    </label>
                                </div>*/}
                                <div className="row">
                                    <label className="col-6 col-form-label">+ Service Tax {process.env.MIX_SERVICE_CHARGE_RATE}% </label>
                                    <label className="col-6 col-form-label text-end">
                                        RM {parseFloat(parseFloat(grossPremium) * (process.env.MIX_SERVICE_CHARGE_RATE / 100))
                                            .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                        }
                                    </label>
                                </div>
                                <div className="row">
                                    <label className="col-6 col-form-label">+ Stamp Duty  </label>
                                    <label className="col-6 col-form-label text-end">RM 10.00</label>
                                </div>
                               <div className="row fw-bold">
                                    <label className="col-6 col-form-label">Total Amount Payable</label>
                                    <label className="col-6 col-form-label text-end">
                                        RM {parseFloat(parseFloat(grossPremium) + 
                                            parseFloat(parseFloat(grossPremium) *  (process.env.MIX_SERVICE_CHARGE_RATE / 100)) + 
                                            10).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                        }
                                    </label>
                                </div>
                            </Card.Footer>
                        </Card>
                        <div className="mb-3 row mt-5 align-items-center">
                            <div className="col-12 text-end" >
                                <Button type="submit" variant="success" id="BtnBuyNow">Buy Now</Button>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Form>
    );
}

function Owner(props) {
    const [ownerName, setOwnerName] = useState("");
    const [ownerContactNo, setOwnerContactNo] = useState("");
    const [ownerIC, setOwnerIC] = useState("");
    const [ownerEmailAdd, setOwnerEmailAdd] = useState("");
    const [ownernationality, setOwnerNationality] = useState("");
    const [ownerAddr1, setOwnerAddr1] = useState("");
    const [ownerAddr2, setOwnerAddr2] = useState("");
    const [ownerAddr3, setOwnerAddr3] = useState("");
    const [ownerPostcode, setOwnerPostcode] = useState("");
    const [ownerstate, setOwnerState] = useState("");
    const [ownercity, setOwnerCity] = useState("");
    const [ownerGender, setOwnerGender] = useState("");
    const [ownerDOB, setOwnerDOB] = useState();
    const [empType] = useState([{ value: 1, label: 'Employed' }, { value: 2, label: 'Unemployed' }, { value: 3, label: 'Retired' }]);
    const [ownerEmploymentType, setOwnerEmploymentType] = useState("");

    useEffect(() => {
        if (props.sumInfo.length !== 0) {
            setOwnerName(props.sumInfo.sumName);
            setOwnerContactNo(props.sumInfo.sumContactNo);
        }
    }, [props.sumInfo]);

    function onGetBrithDateAndGender(e) {
        setOwnerIC(e.target.value);
        var ic = e.target.value;

        if (ic.match(/^(\d{2})(\d{2})(\d{2})-?\d{2}-?\d{4}$/)) {
            setOwnerNationality("Malaysian");

            let gender = parseInt(ic.substr(ic.lastIndexOf('-'))) % 2 == 0 ? 'FEMALE' : 'MALE';
            setOwnerGender(gender);

            let dob = [];
            let date = new Date();

            for (var i = 0; i < ic.length; i += 2) {
                dob.push(parseInt(ic.substr(i, 2)));
            }

            if (dob[0] <= date.getFullYear().toString().slice(-2)) {
                dob[0] += 2000;
            } else {
                dob[0] += 1900;
            }

            setOwnerDOB(new Date(dob[0] + '-' + (dob[1] < 10 ? '0' + dob[1] : dob[1]) + '-' + (dob[2] < 10 ? '0' + dob[2] : dob[2])));
        } else {
            setOwnerNationality('');
            setOwnerGender('');
        }
    }

    function onClickNext(e) {
        const form = e.currentTarget;
        if (form.checkValidity() !== false) {
            e.preventDefault();
            e.stopPropagation();

            props.setOwnerInfo({
                ownerName: ownerName,
                ownerIC: ownerIC,
                ownerContactNo: ownerContactNo,
                ownerEmailAdd: ownerEmailAdd,
                ownernationality: ownernationality,
                ownerAddr1: ownerAddr1,
                ownerAddr2: ownerAddr2,
                ownerAddr3: ownerAddr3,
                ownerPostcode: ownerPostcode,
                ownerstate: ownerstate,
                ownercity: ownercity,
                ownerGender: ownerGender,
                ownerDOB: ownerDOB,
                ownerEmploymentType: ownerEmploymentType.label
            });

            props.setKey("bike");
        }
    }

    function handlePostcodeChange(e) {
        let postcode = e.target.value;

        if (e.target.value.length == 5) {
            axios.get('/api/check-postcode/' + postcode)
                .then((response) => {
                    setOwnerCity(response.data.city);
                    setOwnerState(response.data.state);
                }
            );
        }

        setOwnerPostcode(postcode);
    }

    return (
        <Form validated={false} onSubmit={(e) => onClickNext(e)}>
            <Card>
                <Card.Body>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Full Name</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" disabled required value={ownerName} onChange={(e) => setOwnerName(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">IC No./Passport No.</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" required value={ownerIC} onChange={(e) => onGetBrithDateAndGender(e)} maxLength="12" />
                        </div>
                    </div>

                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Date Of Birth</label>
                        <div className="col-sm-7">
                            <DatePicker
                                className="form-control"
                                selected={ownerDOB}
                                onChange={(date) => { setOwnerDOB(date) }}
                                dateFormat="dd/MM/yyyy"
                            />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Gender</label>
                        <div className="col-sm-7">
                            <div className="form-check form-check-inline">
                                <input type="radio" className="form-check-input" checked={ownerGender === 'MALE'} value='MALE' onChange={(e) => setOwnerGender(e.target.value)} />
                                <label className="form-check-label">Male</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input id="_1" type="radio" className="form-check-input" checked={ownerGender === 'FEMALE'} value='FEMALE' onChange={(e) => setOwnerGender(e.target.value)} />
                                <label className="form-check-label">Female</label>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Employment Type</label>
                        <div className="col-sm-7">
                            <Select 
                                styles={{
                                    menu: provided => ({ ...provided, zIndex: 3 }),
                                    control: provided => ({ ...provided, borderRadius: "2rem" })
                                }}
                                placeholder="Select an employment type"
                                options={empType}
                                value={empType.find(type => type.label === ownerEmploymentType)}
                                onChange={(e) => setOwnerEmploymentType(e)}
                                required
                            />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Contact Number</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" disabled required value={ownerContactNo} onChange={(e) => setOwnerContactNo(e.target.value)} pattern="\d*" maxLength="11" placeholder="012xxxxxxxx" />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Email Address</label>
                        <div className="col-sm-7">
                            <input type="email" className="form-control" required value={ownerEmailAdd} onChange={(e) => setOwnerEmailAdd(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Nationality</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" required value={ownernationality} onChange={(e) => setOwnerNationality(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Address Line 1</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" required value={ownerAddr1} onChange={(e) => setOwnerAddr1(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Address Line 2</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" value={ownerAddr2} onChange={(e) => setOwnerAddr2(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Address Line 3</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" value={ownerAddr3} onChange={(e) => setOwnerAddr3(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Postcode</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" required value={ownerPostcode} onChange={handlePostcodeChange} maxLength={5} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">State</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" required value={ownerstate} onChange={(e) => setOwnerState(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">City</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" required value={ownercity} onChange={(e) => setOwnerCity(e.target.value)} />
                        </div>
                    </div>

                    <div className="mb-3 row">
                        <div className="col-sm-6 d-grid">
                            <Button type="button" variant="success" href="/landing" block>Back</Button>
                        </div>
                        <div className="col-sm-6 d-grid">
                            <Button type="submit" variant="success" block>Next</Button>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </Form>
    );
}

function Bike(props) {
    const [bikeModel, setBikeModel] = useState("");
    const [bikeYear, setBikeYear] = useState("");
    const [bikeStatus, setBikeStatus] = useState("");
    const [bikeSerialNo, setBikeSerialNo] = useState("");
    const [bikeFiles, setBikeFiles] = useState([]);
    const [bikeStatusList, setBikeStatusList] = useState([]);
    const [hasError, setHasError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [iDTxtValue, setiDTxtValue] = useState(0);
    const [eligible, setEligible] = useState(true);
  
    const [manufacturingYearOptions] = useState(Array.from(new Array(5), (val, index) =>
        (new Date()).getFullYear() - index).map((year, index) => { return { value: index, label: year + '' } }));

    let myDivToFocus = React.createRef();

    useEffect(() => {
        axios.get('/api/conditions')
            .then(response => {
                setBikeStatusList(response.data);
            })

    }, []);

    useEffect(() => {
        if (props.sumInfo.length !== 0) {
            setBikeModel(props.sumInfo.sumBikeModel);
        }
    }, [props.sumInfo]);


    function onFileUpload(e) {
        e.preventDefault();
        setiDTxtValue(iDTxtValue + 1);
        let id = e.target.id;
        let file_reader = new FileReader();
        let file = e.target.files[0];
        file_reader.onload = () => {
            setBikeFiles([...bikeFiles, { value: 'bF' + iDTxtValue, label: 'bikeFiles', file: { file_id: id, file_name: file.name, file_type: file.type, uploaded_file: file_reader.result } }]);
        };
        file_reader.readAsDataURL(file);
    }

    function onFileRemove(e) {
        let rows = [...bikeFiles];
        var index = null;
        for (var i = 0; i < rows.length; i++) {
            if (rows[i].value === e.target.value) {
                index = i;
                break;
            }
        }
        if (index !== -1) {
            rows.splice(index, 1);
            setBikeFiles(rows);
        }
    }

    function onClickNext(e) {
        const form = e.currentTarget;
        if (form.checkValidity() !== false) {
            e.preventDefault();
            e.stopPropagation();
            if (bikeStatus === "") {
                setHasError(true);
                setErrorMsg("Kindly provide all information.");
                if (myDivToFocus.current) {
                    myDivToFocus.current.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest"
                    });
                    setTimeout(function () {
                        setHasError(false)
                    }.bind(this), 5000);
                }
            } else {
                props.setBikeInfo({
                    bikeModel: bikeModel,
                    bikeYear: bikeYear,
                    bikeStatus: bikeStatus,
                    bikeSerialNo: bikeSerialNo,
                    bikeFiles: bikeFiles
                });
   		
                props.setKey("payment");
            }
        }
    }

    function onYrManuChange(e) {
        let today = new Date(),
            dob = new Date(e.label).getFullYear();

        if (dob > subYears(today, 5)) {
            setBikeYear(today);
            setEligible(false);
            alert("The purchase year for your bicycle has exceeded 5 years, you are not allow to proceed.");
        } else {
            setBikeYear(dob + '');
            setEligible(true);
        }
    }

    return (
        <Form validated={false} onSubmit={(e) => onClickNext(e)} ref={myDivToFocus}>
            <Card>
                <Card.Body>
                    <div className="mb-3 row">
                        <div className="col-sm-12">
                            <Alert show={hasError} variant="danger">{errorMsg}</Alert>
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Bicycle Make / Model</label>
                        <div className="col-sm-7">
                            <input id="" type="text" className="form-control" disabled value={bikeModel} onChange={(e) => setBikeModel(e.target.value)} placeholder="Trek, Domance SL6 to Trek, Madone SL" />
                        </div>
                    </div>

                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Year of Purchase</label>
                        <div className="col-sm-7">
                            <Select
                                styles={{
                                    menu: provided => ({ ...provided, zIndex: 3 }),
                                    control: provided => ({ ...provided, borderRadius: "2rem" })
                                }}
                                placeholder="Select the purchase year"
                                value={manufacturingYearOptions.find(year => year.label === bikeYear)}
                                options={manufacturingYearOptions}
                                onChange={(e) => onYrManuChange(e)}
                            />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">New / Used</label>
                        <div className="col-sm-7">
                            <Select
                                styles={{
                                    menu: provided => ({ ...provided, zIndex: 3 }),
                                    control: provided => ({ ...provided, borderRadius: "2rem" })
                                }}
                                placeholder="Select condition"
                                value={bikeStatusList.find(obj => obj.label === bikeStatus)}
                                options={bikeStatusList}
                                onChange={(e) => { setBikeStatus(e.label); }}
                            />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Serial Number</label>
                        <div className="col-sm-7">
                            <input id="" type="text" className="form-control" required value={bikeSerialNo} onChange={(e) => setBikeSerialNo(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Please upload a copy of your purchase receipt and a picture of your bicycle</label>
                        <div className="col-sm-7">
                            <div className="input-group mb-3">
                                <div className="custom-file">
                                    <input type="file" name="file_upload" id="file_upload" className="custom-file-input" onChange={(e) => { onFileUpload(e) }} />
                                    <label className="custom-file-label" htmlFor="inputGroupFile" id="fileUploadText" aria-describedby="inputGroupFileAddon"><small>Optional - By providing, it enables faster claims processing.</small></label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: (bikeFiles.length !== 0 ? "block" : "none") }} >
                        <small>
                            <div className="row">
                                <label className="col-sm-1 col-form-label"></label>
                                <label className="col-sm-4 col-form-label text-end">Uploaded purchase receipt and picture of bike</label>
                                <div className="col-sm-7">
                                    {bikeFiles.map((file, index) => (
                                        <ListGroup key={index}>
                                            <ListGroup.Item>
                                                {file.file.file_name}
                                                <Button variant="danger" size="sm" className="float-right" value={file.value} onClick={(e) => onFileRemove(e)}>X</Button>
                                            </ListGroup.Item>
                                        </ListGroup>
                                    ))}
                                </div>
                            </div>
                        </small>
                    </div>
                    <div className="mt-3 d-grid">
                        <Button type="submit" variant="success" block disabled={eligible ? '' : 'disabled'}>Next</Button>
                    </div>
                </Card.Body>		</Card>

        </Form>
    );
}

function Beneficiary(props) {
    const [beneName, setBeneName] = useState("");
    const [beneIC, setBeneIC] = useState("");
    const [beneRelationship, setBeneRelationship] = useState("");
    const [beneRelationshipList, setBeneRelationshipList] = useState([]);
    const [hasError, setHasError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    let myDivToFocus = React.createRef();

    useEffect(() => {
        axios.get('/api/relationships')
            .then(response => {
                setBeneRelationshipList(response.data);
            })
    }, []);

    function onClickNext(e) {
        const form = e.currentTarget;
        if (form.checkValidity() !== false) {
            e.preventDefault();
            e.stopPropagation();
            if (beneRelationship === "") {
                setHasError(true);
                setErrorMsg("Kindly provide all information.");
                if (myDivToFocus.current) {
                    myDivToFocus.current.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest"
                    });
                    setTimeout(function () {
                        setHasError(false)
                    }.bind(this), 5000);
                }
            } else {
                props.setBeneficiaryInfo({
                    beneName: beneName,
                    beneIC: beneIC,
                    beneRelationship: beneRelationship
                });
		
                props.setKey("payment");
            }
        }
    }

    return (
        <Form validated={false} onSubmit={(e) => onClickNext(e)} ref={myDivToFocus}>
            <Card>
                <Card.Body>
                    <div className="mb-3 row">
                        <div className="col-sm-12">
                            <Alert show={hasError} variant="danger">{errorMsg}</Alert>
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-12 fw-bold">Allianz Shield Plus</label>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Beneficiary Name</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" required value={beneName} onChange={(e) => setBeneName(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Beneficiary IC / Passport</label>
                        <div className="col-sm-7">
                            <input type="text" className="form-control" required value={beneIC} onChange={(e) => setBeneIC(e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label className="col-sm-5 col-form-label">Relationship</label>
                        <div className="col-sm-7">
                            <Select
                                styles={{
                                    control: provided => ({ ...provided, borderRadius: "2rem" })
                                }}
                                menuPlacement="top"
                                placeholder="Select relationship"
                                value={beneRelationshipList.find(obj => obj.label === beneRelationship)}
                                options={beneRelationshipList}
                                onChange={(e) => { setBeneRelationship(e.label); }}
                            />
                        </div>
                    </div>
                    <div className="mt-5 mt-5">
                        <Button type="submit" variant="success" block>Next</Button>
                    </div>

                </Card.Body>
            </Card>

        </Form>
    );
}


function Payment(props) {
    let query = new URLSearchParams(useLocation().search);
    const [transactionData, setTransactionData] = useState([]);
    const [transactionNo] = useState(Math.floor(new Date().getTime() / 1000));
    const [isGetSummary, setIsGetSummary] = useState(false);
    const [onSave, setOnSave] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [paShield, setPaShield] = useState(103);
    const [transFilesData, setTransFilesData] = useState([]);
    const [rdPaShield, setRdPaShield] = useState(true);
    const [discountAmount, setDiscountAmount] = useState(0);

    const currentDate = Moment().format('YYYY-MM-D');
    const targetDate =  Moment('2024-03-01').format('YYYY-MM-DD');
    const shouldShowAlert = currentDate < targetDate;

    const commissionStyle = {
        color: "#899499",
        fontSize: "0.625em",
      };

    useEffect(() => {
        if (props.ownerInfo.length !== 0 && props.bikeInfo.length !== 0 &&
            props.sumInfo.length !== 0 ) {

            let prem = parseFloat(parseFloat(props.sumInfo.sumInsured) * 0.04)>=100?parseFloat(parseFloat(props.sumInfo.sumInsured) * 0.04):100 ;
  		let discount = parseFloat(parseFloat(prem) * parseFloat(process.env.MIX_DISC_PERCENTAGE / 100)).toFixed(2);
            let serviceTax = parseFloat(parseFloat(prem) * parseFloat(process.env.MIX_SERVICE_CHARGE_RATE / 100)).toFixed(2);
            setDiscountAmount(discount);

            setTransactionData({
                Owner_name: props.ownerInfo.ownerName,
                Owner_NRICPassport: props.ownerInfo.ownerIC,
                Owner_contactno: props.ownerInfo.ownerContactNo,
                Owner_email: props.ownerInfo.ownerEmailAdd,
                Owner_gender: props.ownerInfo.ownerGender,
                Owner_dob: Moment(props.ownerInfo.ownerDOB).format('YYYY-MM-DD'),
                Owner_employmentType: props.ownerInfo.ownerEmploymentType,
                SumInsured: props.sumInfo.sumInsured,
                premium: prem,
                servicetax: serviceTax,
                stamp_duty: 10,
                total_premium: parseFloat(prem) - parseFloat(discount) + parseFloat(serviceTax) + 10,
                commissionAmount: parseFloat(prem) * parseFloat(process.env.MIX_COMMISION_RATE / 100),
                period_from: props.sumInfo.sumStartDate,
                period_to: props.sumInfo.sumEndDate,
                bike_model: props.bikeInfo.bikeModel,
                bike_YearofManu: props.bikeInfo.bikeYear,
                bike_neworused: props.bikeInfo.bikeStatus,
                bike_serialno: props.bikeInfo.bikeSerialNo,                
                insurer: "Allianz General Insurance Company (Malaysia) Berhad",
                plan_name: "Plan 1",
                Owner_nationality: props.ownerInfo.ownernationality,
                Owner_address1: props.ownerInfo.ownerAddr1,
                Owner_address2: props.ownerInfo.ownerAddr2,
                Owner_address3: props.ownerInfo.ownerAddr3,
                Owner_postcode: props.ownerInfo.ownerPostcode,
                Owner_state: props.ownerInfo.ownerstate,
                Owner_city: props.ownerInfo.ownercity,
                Owner_country: props.ownerInfo.ownercountry,
                TransactionNo: transactionNo
            });

            setTransFilesData(props.bikeInfo.bikeFiles);
        } else if (query.get("paymentID") !== null) {
            axios.get('/api/order/' + query.get("paymentID"))
                .then(res => {
                    var trans = res.data[0]['trans'];
                    setTransactionData({
                        Owner_name: trans.Owner_name,
                        Owner_NRICPassport: trans.Owner_NRICPassport,
                        Owner_contactno: trans.Owner_contactno,
                        Owner_email: trans.Owner_email,
                        Owner_gender: props.ownerInfo.ownerGender,
                        Owner_dob: Moment(props.ownerInfo.ownerDOB).format('YYYY-MM-DD'),
                        Owner_employmentType: trans.Owner_employmentType,
                        SumInsured: trans.SumInsured,
                        premium: trans.premium,
                        servicetax: trans.servicetax,
                        stamp_duty: trans.stamp_duty,
                        total_premium: trans.total_premium,
                        commissionAmount: parseFloat(trans.premium) * parseFloat(process.env.MIX_COMMISION_RATE / 100),
                        period_from: trans.period_from,
                        period_to: trans.period_to,
                        bike_model: trans.bike_model,
                        bike_YearofManu: trans.bike_YearofManu,
                        bike_neworused: trans.bike_neworused,
                        bike_serialno: trans.bike_serialno,                        
                        insurer: trans.insurer,
                        plan_name: trans.plan_name,
                        Owner_nationality: props.ownerInfo.ownernationality,
                        Owner_address1: props.ownerInfo.ownerAddr1,
                        Owner_address2: props.ownerInfo.ownerAddr2,
                        Owner_address3: props.ownerInfo.ownerAddr3,
                        Owner_postcode: props.ownerInfo.ownerPostcode,
                        Owner_state: props.ownerInfo.ownerstate,
                        Owner_city: props.ownerInfo.ownercity,
                        Owner_country: props.ownerInfo.ownercountry,
                        TransactionNo: trans.TransactionNo,
                        payment_status: trans.payment_status,
                        txn_message: trans.txn_message
                    });
                    setIsGetSummary(true);
                })
        }
    }, [props.ownerInfo, props.bikeInfo, props.sumInfo, paShield]);

    useEffect(() => {
        setPaShield(rdPaShield === true ? 103 : 0);
    }, [rdPaShield]);

    useEffect(() => {
        if (onSave === true && transactionData.length !== 0) {
            axios({
                method: 'POST',
                url: '/api/inserttransaction',
                headers: {
                    "content-type": "application/json",
                },
                data: {
                    trans: transactionData,
                    bikefiles: transFilesData
                }
            })
                .then(function (response) {
                    console.log(response);
                    document.getElementById('details-form').submit();
                })
                .catch(function (error) {
		  
                    console.log(error);
                })
        }
    }, [onSave]);

    let merchantAcc = process.env.MIX_PAYMENT_GATEWAY_PASSWORD;
    let serviceID = process.env.MIX_PAYMENT_GATEWAY_SERVICE_ID;
    let merchantReturnURL = process.env.MIX_APP_URL + "/api/store";
    let MerchantCallbackURL =  process.env.MIX_APP_URL + "/api/callback";
    let currencyCode = "MYR";
    let ip = process.env.MIX_PAYMENT_CUST_IP;
    let timeout = "600";
    let HashValue = SHA256(merchantAcc + serviceID + transactionNo + merchantReturnURL + MerchantCallbackURL + Number(transactionData.total_premium).toFixed(2) + currencyCode + ip + timeout);

    function PaymentSuccess() {
        return (<div className="alert alert-success" role="alert">
            {transactionData.txn_message}
        </div>);
    }

    function PaymentFail() {
        return (<div className="alert alert-danger" role="alert">
            {transactionData.txn_message}
        </div>);
    }

    function PaymentPending() {
        return (<div className="alert alert-warning" role="alert">
            Your Payment is still Pending.
        </div>);
    }

    function Message() {
        if (transactionData.payment_status == 'Pending') {
            return <PaymentPending />;
        } else if (transactionData.payment_status == 'Success') {
            return <PaymentSuccess />;
        } else if (transactionData.payment_status == 'Fail')
            return <PaymentFail />
        else return <></>
    }

    return (
        <div>
            {transactionData.length !== 0 ?
                <Form action={process.env.MIX_PAYMENT_GATEWAY_URL} method="POST" id="details-form">
                    <input type="hidden" name="TransactionType" value="SALE" />
                    <input type="hidden" name="PymtMethod" value="ANY" />
                    <input type="hidden" name="ServiceID" value={serviceID} />
                    <input type="hidden" name="PaymentID" value={transactionNo} />
                    <input type="hidden" name="OrderNumber" value={transactionNo} />
                    <input type="hidden" name="PaymentDesc" value="Payment for Bicycle Protection" />
                    <input type="hidden" name="MerchantReturnURL" value={merchantReturnURL} />
                    <input type="hidden" name="MerchantCallbackURL" value={MerchantCallbackURL} />
                    <input type="hidden" name="Amount" value={Number(transactionData.total_premium).toFixed(2)} />
                    <input type="hidden" name="CurrencyCode" value={currencyCode} />
                    <input type="hidden" name="CustName" value={transactionData.Owner_name} />
                    <input type="hidden" name="CustPhone" value={transactionData.Owner_contactno} />
                    <input type="hidden" name="CustEmail" value={transactionData.Owner_email} />
                    <input type="hidden" name="CustIP" value={ip} />
                    <input type="hidden" name="PageTimeout" value={timeout} />
                    <input type="hidden" name="LanguageCode" value="en" />
                    <input type="hidden" name="HashValue" value={HashValue} />
                    <div className="px-3 row">
                        <div className="col-12">
                            <div className="my-2">
                                {isGetSummary ? <Message /> : null}
                            </div>
                            <Card className="my-2">
                                <Card.Header className="text-primary fw-bold">Summary of Policy</Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">

                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Insurer</label>
                                                <label className="col-6 col-form-label text-end">{transactionData.insurer}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Product</label>
                                                <label className="col-6 col-form-label text-end">Bicycle Protection</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Coverage Starts</label>
                                                <label className="col-6 col-form-label text-end">{Moment(transactionData.period_from).format('Do MMM YYYY')}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Coverage Ends</label>
                                                <label className="col-6 col-form-label text-end">{Moment(transactionData.period_to).format('Do MMM YYYY')}</label>
                                            </div>
                                        </div>
                                        <div id="payment" className="col-md-6">

                                            <div className="mb-3 row mb-0">
                                                <label className="col-12 col-form-label fw-bold pb-0">Bicycle Accidental Damage</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Sum Insured</label>
                                                <label className="col-6 col-form-label text-end">RM {parseFloat(transactionData.SumInsured).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Premium</label>
                                                <label className="col-6 col-form-label text-end">RM {(parseFloat(transactionData.SumInsured) * 0.04>=100 ? parseFloat(transactionData.SumInsured) * 0.04:100).toLocaleString(undefined, { minimumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Stamp Duty</label>
                                                <label className="col-6 col-form-label text-end">RM 10.00</label>
                                            </div>
					   <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Service Tax {process.env.MIX_SERVICE_CHARGE_RATE}%</label>
                                                <label className="col-6 col-form-label text-end">RM {transactionData.servicetax.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</label>
                                            </div>
                                            {/*<div className="mb-3 row mb-0">
                                                <label className="col-12 col-form-label fw-bold pb-0">
                                                    <input
                                                        name="rdPaShield"
                                                        id="rdPaShieldYes"
                                                        type="checkbox"
                                                        className="form-check-input mt-2"
                                                        defaultChecked={rdPaShield}
                                                        onChange={() => setRdPaShield(!rdPaShield)}
                                                        disabled
                                                    />
                                                        Allianz Shield Plus
                                                </label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Sum Insured</label>
                                                <label className="col-6 col-form-label text-end">RM 60,000.00</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Premium</label>
                                                <label className="col-6 col-form-label text-end">RM 103.00</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Stamp Duty</label>
                                                <label className="col-6 col-form-label text-end">RM 10.00</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Service Tax 8%</label>
                                                <label className="col-6 col-form-label text-end">RM {transactionData.servicetax.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</label>
                                            </div>*/}
                                        </div>
                                    </div>
                                </Card.Body>
				<Card.Footer>                                   
                                    <div className="row fw-bold">
                                        <label className="col-6 col-form-label">Total Amount Payable</label>
                                        <label className="col-6 col-form-label text-end">RM {transactionData.total_premium.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</label>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div style={commissionStyle}>{process.env.MIX_COMMISION_RATE}% of commission amounting to RM {parseFloat(transactionData.commissionAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} is payable to intermediary.</div>
                                        </div>
                                    </div>
                                </Card.Footer>
                                {/*<Card.Footer>
                                    <div className="mb-3 row bg-primary text-white">
                                        <label className="col-6 col-form-label">{process.env.MIX_DISC_PERCENTAGE}% Rebate</label>
                                        <label className="col-6 col-form-label text-end">RM {discountAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</label>
                                    </div>
                                    <div className="row fw-bold">
                                        <label className="col-6 col-form-label">Total Amount Payable</label>
                                        <label className="col-6 col-form-label text-end">RM {transactionData.total_premium.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</label>
                                    </div>
                                </Card.Footer>*/}
                            </Card>
                            <Card>
                                <Card.Header className="text-primary fw-bold">Insured Details</Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Full Name</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.Owner_name}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">IC No./Passport No.</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.Owner_NRICPassport}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Gender</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.Owner_gender}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Employment Type</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.Owner_employmentType}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Date Of Birth</label>
                                                <label className="col-6 col-form-label text-end text-primary">{Moment(transactionData.Owner_dob).format('Do MMM YYYY')}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Contact Number</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.Owner_contactno}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-5 col-form-label">Email</label>
                                                <label className="col-7 col-form-label text-end text-primary">{transactionData.Owner_email}</label>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Card className="my-3">
                                <Card.Header className="text-primary fw-bold">My Bicycle Information</Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Bicycle Make / Model</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.bike_model}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Year of Manufacture</label>
                                                <label className="col-6 col-form-label text-end text-primary">{Moment(transactionData.bike_YearofManu).year()}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">New / Used</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.bike_neworused}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <label className="col-5 col-form-label">Serial Number</label>
                                                <label className="col-7 col-form-label text-end text-primary">{transactionData.bike_serialno}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-5 col-form-label">No. of File(s) Uploaded</label>
                                                <label className="col-7 col-form-label text-end text-primary">{props.bikeInfo.bikeFiles.length}</label>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                            {/*<Card className="mb-3">
                                <Card.Header className="text-primary fw-bold">Beneficiary Details for PA</Card.Header>
                                <Card.Body>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Beneficiary Name</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.beneficiary_name}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Beneficiary IC / Passport</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.beneficiary_NRIC}</label>
                                            </div>
                                            <div className="mb-3 row">
                                                <label className="col-6 col-form-label">Relationship</label>
                                                <label className="col-6 col-form-label text-end text-primary">{transactionData.beneficiary_relationship}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>*/}
                             <div className='col-lg-12'>
                                {shouldShowAlert && (
                                    <div className="alert alert-danger" role="alert">
                                        Disclaimer: As announced by the government in the Budget 2024, <b>effective from 1st March 2024</b>, the adjustment of service tax from <b>6% to 8%</b> is applicable to all insurance services. Please be informed that any modifications or augmentation in service tax attributable to this revision is the responsibility of the insurance policy holder. The additional payable service tax is also applicable to any policy that is procured before 1st March 2024 but with a period of insurance spanning across 1st March 2024. Therefore, Howden Insurance Brokers Sdn Bhd reserves the right to collect any additional service tax on behalf of the Royal Malaysian Customs Department.
                                    </div>
                                )}
                            </div> 

                             <div className='col-lg-12 d-grid'>
                            <Button type="button" variant="success" className="mb-3" block disabled={isGetSummary ? 'disabled' : ""} onClick={() => setModalShow(true)}>Pay Now</Button>
                            </div>
                            <PromptConfirmation show={modalShow} onHide={() => setModalShow(false)} Owner_name={transactionData.Owner_name} setOnSave={setOnSave} />
                        </div>
                    </div>
                </Form>
                :
                <div className="text-center">
                    <br />
                    <img src="../images/loading.gif" />
                    <br />
                    Please wait
                    <br />
                </div>
            }
        </div >
    );
}

function PromptConfirmation(props) {
    const [agreed, setAgreed] = useState(null);

const useAnalyticsEventTracker = (category="Instapol - GA4 category") => {
 	 const eventTracker = (action = "test action", label = "test label") => {
 	   ReactGA.event({category, action, label});
  	}
  	return eventTracker;
	}
const gaEventTracker = useAnalyticsEventTracker('Payment');

    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header>
                <Modal.Title>Confirmation</Modal.Title>
                 <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={props.onHide}></button>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-12 text-justify">
                        <div className="col-12">I, <span className="text-primary">{props.Owner_name}</span>, confirm that:</div>
                        <div className="col-12 mt-4">
                            <p>I am not a bankruptcy or currently undergoing any bankruptcy/insolvency proceedings, or been convicted in any court of law or subject to legal proceedings in any country.</p>
                                            </div>
                        <div className="row text-center mt-4">
                            <div className="col-12">
                                <input type="radio" value="true" name="disclosure" onChange={() => setAgreed(true)} /> Agree
                                <input className="ms-4" type="radio" value="false" name="disclosure" onChange={() => setAgreed(false)} /> Disagree
                            </div>
                            {(agreed === false) ?
                                    <div className="col-12 text-danger">You have to agree to our terms in order to complete the transaction.</div>
                                    : ''
                            }
                        </div>
                        <div className="col-12 mt-4">
                            <strong>
                                Please make sure you review the order and personal details before payment page. Once you click 'Pay Now' you cannot
                                change these details.
                            </strong>
                        </div>
                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <div className="row text-end">
                    <div className="col-5">
                        <Button type="button" variant="secondary" onClick={props.onHide}>Cancel</Button>
                    </div>
                    <div className="col-7">
                        <Button type="button" variant="success" form="details-form" disabled={isNull(agreed) || agreed === false ? 'disabled' : ''} onClick={(e) => { props.setOnSave(true);gaEventTracker('email'); }}>Pay Now</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}
